import {
  Icon,
  List,
  ListItem,
  Table,
  TableHeader,
  TableHeaderCell,
  TableRow,
} from "semantic-ui-react";
import { useCallback, useState } from "react";

// Components
import BroadcastTableRow from "./BroadcasatTableRow";

// Styles
import "./styles/BroadcastListTable.scss";

// Utils
// import moment from "moment";

// Serializers
import BroadcastPostSerializer from "@/issara-sdk/types/BroadcastPostSerializer_apps_PRX";

// Interface
import { ICONS } from "./sequence/MeCast";

// Types
import { BroadcastAction } from "./MeCastType";

type PreviewData = {
  text: string;
  media: string | null;
};

type BroadcastListTableProps = {
  // --- data
  data: BroadcastPostSerializer[];
  previews: Record<string, PreviewData>;
  selectedAction: number | null;
  // --- actions
  getActions: (row: BroadcastPostSerializer) => BroadcastAction[];
  onAction: (row: BroadcastPostSerializer, action: BroadcastAction) => void;
  onSelectAction: (idx: number) => void;
};

const EMPTY_PREVIEW: PreviewData = { text: "", media: null };

const EmptyState = () => (
  <Table.Row>
    <Table.Cell
      colSpan={7}
      textAlign="center"
      style={{ padding: "20px", color: "#999", fontSize: "24px" }}
    >
      <img
        src={ICONS.broadcast}
        style={{
          width: "50px",
          height: "50px",
          marginBottom: "-10px",
          marginRight: "10px",
        }}
        alt="No broadcasts"
      />
      No broadcast messages found
    </Table.Cell>
  </Table.Row>
);

const BroadcastListTable = (props: BroadcastListTableProps) => {
  // const [hoverIndex, setHoverIndex] = useState<number | null>(null);

  const handleAction = useCallback(
    (row: BroadcastPostSerializer) => (action: BroadcastAction) => {
      props.onAction(row, action);
    },
    [props.onAction]
  );

  return (
    <div className="table-broadcast-list">
      {/* --- Table Section --- */}
      <Table basic structured selectable>
        <TableHeader>
          <TableRow>
            <TableHeaderCell style={{ paddingLeft: "10px" }}>ID</TableHeaderCell>
            <TableHeaderCell>Post/Details</TableHeaderCell>
            <TableHeaderCell style={{ paddingLeft: "10px" }}>Group Name</TableHeaderCell>
            <TableHeaderCell style={{ paddingLeft: "10px" }}>Schedule Date</TableHeaderCell>
            <TableHeaderCell style={{ paddingLeft: "10px" }}>Status</TableHeaderCell>
            <TableHeaderCell style={{ textAlign: "center" }}>Receiver(s)</TableHeaderCell>
            <TableHeaderCell />
          </TableRow>
        </TableHeader>

        <Table.Body>
          {props.data.length === 0 ? (
            <EmptyState />
          ) : (
            props.data.map((row, idx) => (
              <BroadcastTableRow
                key={row.id}
                row={row}
                preview={props.previews[row.firebase_id] || EMPTY_PREVIEW}
                actions={props.getActions(row)}
                isActionOpen={props.selectedAction === idx}
                onToggleAction={() => props.onSelectAction(idx)}
                onAction={handleAction(row)}
              />
            ))
          )}
        </Table.Body>
      </Table>
    </div>
  );
};

export default BroadcastListTable;
